import React from 'react';
import urls, { relativeUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const TaskListAction = () => (
  <RibbonMenu
    name="tasks"
    icon="tasks"
    message="actions.tasks.list"
    url={`#${relativeUrl(urls.TASKS)}`}
    className="aridhia-task-list-action whitespace-nowrap"
  />
);

export default TaskListAction;
